import * as React from 'react'
import { observer } from 'mobx-react'
import { TableVirtuoso } from 'react-virtuoso'
import {
  TableScrollingContainer,
  TableBody,
  TableHead,
  Table,
} from 'components/Table'
import type InfiniteScrollProvider from 'utils/InfiniteScrollProvider'
import VirtualStripedTableRow from '../VirtualStripedTableRow'
import VirtualTableInfiniteScrollLoader, {
  OnClickItemRow,
} from '../VirtualTableInfiniteScrollLoader'

interface VirtualTableProps<S> {
  totalCount: number
  scroller: InfiniteScrollProvider<S, any>
  overscan?: number
  itemContent: (index: number) => React.ReactNode
  headerContent: () => React.ReactNode
  onClickItemRow?: OnClickItemRow<S>
}

/**
 * The VirtualTable
 */
export default observer(function VirtualTable<S>({
  totalCount,
  scroller,
  overscan,
  itemContent,
  headerContent,
  onClickItemRow,
}: VirtualTableProps<S>) {
  return (
    <TableVirtuoso
      totalCount={totalCount}
      endReached={() => scroller.more()}
      overscan={overscan}
      context={{
        scroller,
        onClickItemRow,
      }}
      components={{
        Table,
        TableHead,
        TableBody,
        TableRow: VirtualStripedTableRow,
        Scroller: TableScrollingContainer,
        // Not used as the actual placeholder; this is used to show an
        // infinite scroll zone. The `endReached` isn't sufficient.
        TableFoot: VirtualTableInfiniteScrollLoader,
      }}
      itemContent={itemContent}
      fixedHeaderContent={headerContent}
      fixedFooterContent={() => true}
    />
  )
})
